export const modalWidthPresets = {
  detail: 'min(1680px, calc(100vw - 48px))',
  wideForm: 'min(1440px, calc(100vw - 48px))',
  medium: 'min(920px, calc(100vw - 48px))',
  large: 'min(1040px, calc(100vw - 48px))',
  xlarge: 'min(1180px, calc(100vw - 48px))',
} as const;

export type ModalWidthPreset = keyof typeof modalWidthPresets;

export const getResponsiveModalWidth = (
  preset: ModalWidthPreset,
  fallback?: number | string,
) => fallback ?? modalWidthPresets[preset];
